import React from 'react'
import { SocialLoginButton, PICO_API_URL, Button } from '../../dependencies'
import cx from 'classnames'
import { TikTokIcon } from '../icons'

const TikTokLogin = ({ onLoginSuccess, onLoginFailure, processing = false, userId, hypeUsername, socialUsername, onButtonClick = () => {} }) => {
    return (
        <div className='flex justify-center'>
            <SocialLoginButton
                key={'tiktok'}
                scope='claim'
                params={{ hype_username: hypeUsername , social_username: socialUsername }}
                type={'tiktok'}
                api_url={PICO_API_URL()}
                userId={userId}
                disabled={processing}
                button={
                    <Button
                        color='secondary'
                        fullWidth
                        disabled={processing}
                        startIcon={<TikTokIcon />}
                        className={cx(
                            'btn-social',
                            {
                                processing: 'cursor-not-allowed'
                            }
                        )}
                    >
                        <span className={cx('w-full', 'plausible-event-name=Signup+Step+1a', 'plausible-event-method=Google')}>{processing ? 'Processing...' : 'Verify with TikTok'}</span>
                    </Button>
                }
                onLogin={onLoginSuccess}
                onFailure={onLoginFailure}
                onClick={onButtonClick}
            />
        </div>
    )

}

export default TikTokLogin
